import { render, staticRenderFns } from "./CooperateStep2.vue?vue&type=template&id=0f0781d3&scoped=true"
import script from "./CooperateStep2.vue?vue&type=script&lang=js"
export * from "./CooperateStep2.vue?vue&type=script&lang=js"
import style0 from "./CooperateStep2.vue?vue&type=style&index=0&id=0f0781d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0781d3",
  null
  
)

export default component.exports